import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'
import MaskedInputWrap from '.././maskedInputWrap.jsx'
import RequestTFACode from '../requestTFACode.js'
import CommonFetch from '../../../requests/commonFetch'

export default class TFA extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectTypeDisplay: true,
            currentCodeDisplay: false,
            receivedCodeDisplay: false,
            selectedTypeTFA: '',
            currentCode: '',
            receivedCode: '',
            ga_secret: '',
            ga_img_url: '',
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    postChange2fatype = () => {
        let formData = new FormData()
        if (this.props.twoFaType !== 'none') {
            formData.append('2fa_code', this.state.currentCode)
        }

        formData.append(
            '2fa_type',
            this.state.selectedTypeTFA.toLowerCase().indexOf('google') >= 0
                ? 'ga'
                : this.state.selectedTypeTFA.toLowerCase()
        )

        CommonFetch({
            path: 'ui/investor_settings/post_change2fatype',
            method: 'POST',
            data: formData,
        }).then(data => {
            console.log(data)
            if (data.error === 'wrong_2fa_code') return null

            let { currentCodeDisplay, receivedCodeDisplay } = this.state

            if (data.success && this.state.selectedTypeTFA === 'None') {
                this.props.switchCheckDisplay()
                this.props.switchStatusTFAType()
                this.props.switchTFAType(
                    this.state.selectedTypeTFA.toLowerCase()
                )
            } else if (
                data.ga_secret &&
                data.ga_img_url &&
                this.props.twoFaType === 'none'
            ) {
                this.setState({
                    ga_secret: data.ga_secret,
                    ga_img_url: data.ga_img_url,
                })
            } else if (
                data.ga_secret &&
                data.ga_img_url &&
                this.props.twoFaType !== 'none'
            ) {
                this.setState({
                    currentCodeDisplay: !currentCodeDisplay,
                    receivedCodeDisplay: !receivedCodeDisplay,
                    ga_secret: data.ga_secret,
                    ga_img_url: data.ga_img_url,
                })
            } else if (this.props.twoFaType !== 'none') {
                this.setState({
                    currentCodeDisplay: !currentCodeDisplay,
                    receivedCodeDisplay: !receivedCodeDisplay,
                })
            }
        })
    }

    postConfirm2fatype = () => {
        let formData = new FormData()
        formData.append('new_type_code', this.state.receivedCode)

        CommonFetch({
            path: 'ui/investor_settings/post_confirm2fatype',
            method: 'POST',
            data: formData,
        }).then(data => {
            if (data.success) {
                this.props.dataProtection('update')
                this.props.getStatus()
                this.props.switchCheckDisplay()
            }
        })
    }

    render() {
        let {
            selectTypeDisplay,
            currentCodeDisplay,
            receivedCodeDisplay,
            selectedTypeTFA,
            ga_secret,
            ga_img_url,
        } = this.state

        return (
            <div className="tfa-new">
                {this.tfaTitle()}
                {this.tfaInfo()}
                {this.tfaSelect()}
                {this.tfaForm()}
                <button
                    className={
                        selectedTypeTFA
                            ? 'tfa-new__button'
                            : 'tfa-new__button __non-clickable'
                    }
                    onClick={this.firstButton}
                >
                    {selectTypeDisplay
                        ? this.translation['next']
                        : this.translation['Check']}
                </button>

                <button
                    className="tfa-new__button __close"
                    onClick={this.props.switchCheckDisplay}
                >
                    {this.translation['Close']}
                </button>
                {ga_secret && ga_img_url ? (
                    <div className="tfa-new__googleAuth">
                        <div
                            className="tfa-new__googleAuth_image"
                            style={{ backgroundImage: `url(${ga_img_url})` }}
                        />
                        <div className="tfa-new__googleAuth_info">
                            <h2>
                                {
                                    this.translation[
                                        'Set Up two-factor authentication with Google Authenticator'
                                    ]
                                }
                            </h2>
                            <p>
                                {
                                    this.translation[
                                        'After installing the Google Authenticator app scan the QR code below and enter the verification code you see in the Google Authenticator App'
                                    ]
                                }
                            </p>
                            <p>
                                {this.translation['Secret code']}:{' '}
                                <span>{ga_secret}</span>
                            </p>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }

    firstButton = () => {
        let {
            selectedTypeTFA,
            selectTypeDisplay,
            currentCodeDisplay,
            receivedCodeDisplay,
            currentCode,
            receivedCode,
        } = this.state
        let { twoFaType } = this.props

        if (selectedTypeTFA && selectTypeDisplay) {
            if (twoFaType === 'none') {
                this.postChange2fatype()
                this.setState({
                    selectTypeDisplay: !selectTypeDisplay,
                    receivedCodeDisplay: !receivedCodeDisplay,
                })
            } else {
                if (twoFaType !== 'ga') RequestTFACode()
                this.setState({
                    selectTypeDisplay: !selectTypeDisplay,
                    currentCodeDisplay: !currentCodeDisplay,
                })
            }
        } else if (currentCode.length === 6 && currentCodeDisplay) {
            this.postChange2fatype()
        } else if (receivedCode.length === 6 && receivedCodeDisplay) {
            this.postConfirm2fatype()
        }
    }

    tfaTitle = () => {
        let { selectTypeDisplay, currentCodeDisplay } = this.state
        let title = ''

        if (selectTypeDisplay) {
            title = this.translation[
                'Select the type of two-factor authentication'
            ]
        } else if (currentCodeDisplay) {
            title = this.translation['Enter the current code']
        } else {
            title = this.translation['Enter the received code']
        }

        return <p className="tfa-new__title">{title}</p>
    }

    tfaInfo = () => {
        let {
            selectTypeDisplay,
            selectedTypeTFA,
            currentCodeDisplay,
            receivedCodeDisplay,
        } = this.state
        let { twoFaType } = this.props

        if (selectTypeDisplay) {
            return (
                <p className="tfa-new__info">
                    {this.translation['Type of two-factor authentication']}:
                    <span>
                        {' '}
                        {twoFaType === 'ga'
                            ? 'google authenticator'
                            : twoFaType === 'sms'
                            ? 'SMS'
                            : twoFaType}
                    </span>
                </p>
            )
        }

        if (currentCodeDisplay) {
            return (
                <p className="tfa-new__info">
                    {
                        this.translation[
                            'Current type of two-factor authentication'
                        ]
                    }
                    :
                    <span>
                        {' '}
                        {twoFaType === 'ga'
                            ? 'google authenticator'
                            : twoFaType === 'sms'
                            ? 'SMS'
                            : twoFaType}
                    </span>
                </p>
            )
        } else if (receivedCodeDisplay) {
            return (
                <p className="tfa-new__info">
                    {
                        this.translation[
                            'Selected type of two-factor authentication'
                        ]
                    }
                    :<span> {selectedTypeTFA}</span>
                </p>
            )
        }
    }

    tfaSelect = () => {
        let { selectTypeDisplay } = this.state
        let { twoFaType } = this.props

        if (!selectTypeDisplay) return null

        let arrAvailableTypes = this.props.tfaAvailableTypes.map((item, i) => {
            if (item !== twoFaType) {
                if (item === 'Email') {
                    return <option key={i + 1}>Email</option>
                } else if (item === 'SMS') {
                    return <option key={i + 1}>SMS</option>
                } else if (item === 'Google authenticator') {
                    return <option key={i + 1}>Google Authenticator</option>
                } else if (item === 'none') {
                    return <option key={i + 1}>None</option>
                }
            }
        })

        arrAvailableTypes.unshift(
            <option key={0}>{this.translation['Select type…']}</option>
        )
        return (
            <select
                className="tfa-new__select"
                value={this.state.selectedTypeTFA}
                onChange={this.changeTypeTFA}
            >
                {arrAvailableTypes}
            </select>
        )
    }

    tfaForm = () => {
        let {
            selectTypeDisplay,
            currentCodeDisplay,
            currentCode,
            receivedCode,
        } = this.state

        if (selectTypeDisplay) return null

        return (
            <MaskedInputWrap
                type={'tfa_code'}
                styles={'tfa-new__form'}
                value={currentCodeDisplay ? currentCode : receivedCode}
                changeValue={this.changeFormValue}
                showMask={true}
                placeholderChar="&#xFF3F;"
            />
        )
    }

    changeFormValue = e => {
        let { currentCodeDisplay, receivedCodeDisplay } = this.state

        if (currentCodeDisplay) {
            this.setState({
                currentCode: e.target.value.replace(/[^A-Za-z0-9|S]/g, ''),
            })
        } else if (receivedCodeDisplay) {
            this.setState({
                receivedCode: e.target.value.replace(/[^A-Za-z0-9|S]/g, ''),
            })
        }
    }

    changeTypeTFA = e => {
        this.setState({
            selectedTypeTFA:
                e.target.value === 'Select type…' ? '' : e.target.value,
        })
    }
}
